/*********************************************************************************************
* Initialize the sticky CTA behavior.
	*
*/
let stickySplideInstance = null;

function initializeStickyCTA() {
	const classicCTA = document.querySelector('[data-cta]');
	const stickyCTA = document.querySelector('[data-sticky-cta]');


	// Vérifie que les éléments existent
	if (!classicCTA || !stickyCTA) {
		console.error("Les éléments [data-cta] ou [data-sticky-cta] n'existent pas.");
		return;
	}

	// Crée un observateur pour surveiller la visibilité du CTA principal
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) {
				// Si le CTA principal n'est plus visible
				stickyCTA.classList.remove('mm-none');
			} else {
				// Si le CTA principal est visible
				stickyCTA.classList.add('mm-none');
			}
		});
	}, {
		root: null,
		threshold: 0,
		rootMargin: '-20px 0px 0px 0px' // Ajoute une marge pour déclencher un peu plus tôt
	});

	// Lancer l'observation du CTA principal
	observer.observe(classicCTA);

  if (!!observer) {

  	const mainSplide = document.querySelector('.mm-splide-rea-sticky');
	if (mainSplide) {
		new Splide(mainSplide, {
			type: 'loop',
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			arrows: false,
			pagination: true,
			rewind: true,
			gap: 12,
			perPage: 1,
			breakpoints: {
				768: {
					perPage: 1,
					gap: 8
				}
			}
		}).mount();
	}

     const mainSplideOrder = document.querySelector('.mm-splide-rea-sticky-order');
	if (mainSplideOrder) {
		new Splide(mainSplideOrder, {
			type: 'loop',
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			arrows: false,
			pagination: true,
			rewind: true,
			gap: 12,
			perPage: 1,
			breakpoints: {
				768: {
					perPage: 1,
					gap: 8
				}
			}
		}).mount();
	}

  }
}

  /*********************************************************************************************
* Initialize the Splide Reassurance.
	*
*/
function mmInitSplideReaProduct() {
	// Initialiser le Splide principal
	const mainSplide = document.querySelector('.mm-splide-rea');
	if (mainSplide) {
		new Splide(mainSplide, {
			type: 'loop',
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			arrows: false,
			pagination: true,
			rewind: true,
			gap: 12,
			perPage: 1,
			breakpoints: {
				768: {
					perPage: 1,
					gap: 8
				}
			}
		}).mount();
	}
}
function mmInitSplideReaProductOrder() {
	// Initialiser le Splide principal
	const mainSplide = document.querySelector('.mm-splide-rea-order');
	if (mainSplide) {
		new Splide(mainSplide, {
			type: 'loop',
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			arrows: false,
			pagination: true,
			rewind: true,
			gap: 12,
			perPage: 1,
			breakpoints: {
				768: {
					perPage: 1,
					gap: 8
				}
			}
		}).mount();
	}
}

window.addEventListener('scroll', function (e) {
	derniere_position_de_scroll_connue = window.scrollY;

	// if (!ticking) {
	// 	window.requestAnimationFrame(function () {
	// 		mmCtaSticky(derniere_position_de_scroll_connue);
	// 		ticking = false;
	// 	});
	// }

	handleModalePediPosition();
});

function handleModalePediPosition() {
	const modalPedi = document.getElementById('modalePedimetre');
	const header = document.querySelector('.mm-section-header');

	if (modalPedi && header) {
		const headerRect = header.getBoundingClientRect();
		const headerBottom = headerRect.bottom;
		modalPedi.style.top = `${headerBottom}px`;
	}
}



//  ADD product complementary smiley
function mmHandleAddOrRemoveProduct(element) {
	const variantId = element.getAttribute("data-variant-id");
	const isChecked = element.checked;

	console.log('Debug - variantId récupéré:', variantId);
	console.log('Debug - isChecked:', isChecked);

	// Trouver tous les upsells avec le même variantId
	const allUpsells = document.querySelectorAll(`[data-variant-id="${variantId}"]`);

	// Mettre à jour tous les upsells
	allUpsells.forEach(upsell => {
		upsell.checked = isChecked;
	});

	if (isChecked) {
		mmAddProductToCartComplementary(variantId);
		console.log("Produit ajouté au panier : " + variantId);
		updateCTAPrice(element, true);
	} else {
		mmDestroyProductFromCartComplementary(variantId);
		console.log("Produit supprimé du panier : " + variantId);
		updateCTAPrice(element, false);
	}
}

// Fonction pour mettre à jour le prix du CTA en fonction du produit complémentaire
function updateCTAPrice(element, isAdding) {
	// Trouver le prix du produit complémentaire dans le même conteneur
	const container = element.closest('.mm-container-product-complementary');
	if (!container) return;

	const priceElement = container.querySelector('[data-price]');
	if (!priceElement) return;

	const complementaryPrice = parseFloat(priceElement.getAttribute('data-price'));
	if (isNaN(complementaryPrice)) return;

	// Trouver tous les boutons CTA
	const ctaButtons = document.querySelectorAll('.mm-product-cta');

	ctaButtons.forEach(button => {
		// Récupérer le prix de base depuis l'attribut data-price du bouton
		const basePrice = parseFloat(button.getAttribute('data-price'));
		if (isNaN(basePrice)) return;

		let newPrice;
		if (isAdding) {
			newPrice = basePrice + complementaryPrice;
		} else {
			newPrice = basePrice - complementaryPrice;
		}

		// Mettre à jour l'attribut data-price du bouton
		button.setAttribute('data-price', newPrice);

		// Mettre à jour le prix dans le span du bouton
		const priceSpan = button.querySelector('span');
		if (priceSpan) {
			// Le prix est en centimes, donc on divise par 100 pour obtenir les euros
			const priceText = (newPrice / 100).toFixed(2).replace('.', ',') + "€";
			priceSpan.textContent = priceText;
		}

	});
}

// Fonction spécifique pour ajouter un produit complémentaire sans ouvrir le panier
function mmAddProductToCartComplementary(variantId) {
	fetch('/cart/add.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			items: [{
				id: variantId,
				quantity: 1
			}]
		}),
	})
	.then((response) => response.json())
	.then((data) => {
		console.log('Produit complémentaire ajouté avec succès:', data);
		// Mettre à jour le compteur du panier
		updateCartCountFromResponse(data);
		return data;
	})
	.catch((error) => {
		console.error('Erreur lors de l\'ajout du produit complémentaire:', error);
	});
}

// Fonction spécifique pour supprimer un produit complémentaire sans ouvrir le panier
function mmDestroyProductFromCartComplementary(variantId) {
	fetch('/cart/change.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			id: variantId,
			quantity: 0
		}),
	})
	.then((response) => response.json())
	.then((data) => {
		console.log('Produit complémentaire supprimé avec succès:', data);
		// Mettre à jour le compteur du panier
		updateCartCountFromResponse(data);
		return data;
	})
	.catch((error) => {
		console.error('Erreur lors de la suppression du produit complémentaire:', error);
	});
}

// Fonction pour mettre à jour le compteur du panier à partir de la réponse de l'API
function updateCartCountFromResponse(data) {
	if (data && data.item_count !== undefined) {
		const productCount = data.item_count;
		const countBubbles = document.querySelectorAll(".mm-cart-count-bubble");

		countBubbles.forEach(function(countBubble) {
			countBubble.innerText = productCount;
		});

		console.log('productCount', productCount);

		if (productCount > 0) {
			countBubbles.forEach(function(countBubble) {
				countBubble.classList.remove('mm-none');
			});
		} else {
			countBubbles.forEach(function(countBubble) {
				countBubble.classList.add('mm-none');
			});
			localStorage.setItem("no_free_product_please", "");
		}
	}
}


/*********************************************************************************************
* Change the quantity value in the input field and update the related prices.
	*
	* @param {number} delta - The change to apply to the current quantity (e.g., +1 or -1).
	* @param {string} inputId - The ID of the input field where the quantity is adjusted.
*/
function mmChangeQtty(delta, inputId) {
	let input = document.getElementById(inputId);
	const plusBtn = document.querySelector(`[data-qtty-plus="${inputId}"]`);

	if (delta === -1 && input.value === "1") {
		return;
	} else {
		var newValue = parseInt(input.value, 10) + parseInt(delta, 10);

		// Vérification si la nouvelle valeur atteint ou dépasse le maximum autorisé
		if (input.max && newValue >= parseInt(input.max, 10)) {
			newValue = parseInt(input.max, 10); // Limiter à la valeur maximale
			plusBtn.setAttribute("disabled", "true"); // Désactiver le bouton "+"
		} else {
			plusBtn.removeAttribute("disabled"); // Réactiver le bouton "+" si on est en dessous de la limite
		}

		// Mise à jour de la valeur de l'input
		input.value = newValue;

		// Mise à jour des prix en fonction de la nouvelle quantité
		mmUpdatePrice(newValue);
	}
}

/*********************************************************************************************
* Update the displayed prices based on the new quantity.
	*
	* @param {number} qtty - The current product quantity used to calculate the prices.
*/
function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll("[data-price]");
	var comparePriceAll = document.querySelectorAll("[data-compare-price]");

	// Met à jour les prix normaux
	priceAll.forEach(function (price) {
		var priceValue = parseFloat(price.dataset.price);
		if (!isNaN(priceValue)) {
			price.innerHTML = ((priceValue * qtty) / 100).toFixed(2) + "€";
		} else {
			console.error("Valeur de prix non valide : ", price.dataset.price);
		}
	});

	// Met à jour les prix comparatifs
	comparePriceAll.forEach(function (comparePrice) {
		var comparePriceValue = parseFloat(comparePrice.dataset.comparePrice);
		if (!isNaN(comparePriceValue)) {
			comparePrice.innerHTML = ((comparePriceValue * qtty) / 100).toFixed(2) + "€";
		} else {
			console.error("Valeur de prix comparatif non valide : ", comparePrice.dataset.comparePrice);
		}
	});
}




/*********************************************************************************************
* Class for handling variant selection
	*
*/
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");
		this.addEventListener("change", this.onVariantChange);
	}

	/*********************************************************************************************
	* Handle variant change event.
		*
	*/
	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			if (this.dataset.imageVariant) {
				this.updateImagesVariant();
			} else {
				this.updateMedia();
			}
			this.variantFetch();

			// Synchroniser avec l'autre sélecteur
			const otherSelector = this.classList.contains('variant-selector-sticky')
				? document.querySelector('variant-selector')
				: document.querySelector('variant-selector-sticky');

			if (otherSelector) {
				// Mettre à jour directement les options dans l'autre sélecteur
				const options = this.currentVariant.options;
				const otherCheckboxes = otherSelector.querySelectorAll('.mm-product-variant-checkbox');
				otherCheckboxes.forEach(checkbox => {
					const optionIndex = parseInt(checkbox.getAttribute('data-option-index'));
					if (checkbox.value === options[optionIndex]) {
						checkbox.checked = true;
						const label = checkbox.closest('label');
						if (label) {
							label.classList.add('mm-active');
						}
					} else {
						checkbox.checked = false;
						const label = checkbox.closest('label');
						if (label) {
							label.classList.remove('mm-active');
						}
					}
				});

				// Mettre à jour le variant dans l'autre sélecteur
				otherSelector.currentVariant = this.currentVariant;
				otherSelector.updateURL();
				otherSelector.updateMedia();
				otherSelector.variantFetch();
			}
		}
	}

	updateFromOtherSelector(variant) {
		this.currentVariant = variant;
		this.updateURL();
		if (this.dataset.imageVariant) {
			this.updateImagesVariant();
		} else {
			this.updateMedia();
		}
		this.variantFetch();

		// Mettre à jour les options sélectionnées
		const options = variant.options;
		const checkboxes = this.querySelectorAll('.mm-product-variant-checkbox');
		checkboxes.forEach(checkbox => {
			const optionIndex = parseInt(checkbox.getAttribute('data-option-index'));
			if (checkbox.value === options[optionIndex]) {
				checkbox.checked = true;
				const label = checkbox.closest('label');
				if (label) {
					label.classList.add('mm-active');
				}
			} else {
				checkbox.checked = false;
				const label = checkbox.closest('label');
				if (label) {
					label.classList.remove('mm-active');
				}
			}
		});
	}

	/*********************************************************************************************
	* Get selected options from the variant checkboxes.
		*
	*/
	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
    console.log(this.options);
	}

	/*********************************************************************************************
	* Get variant data from the embedded JSON.
		*
		* @returns {Object} - The variant data.
	*/
	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	/*********************************************************************************************
	* Get the selected variant based on selected options.
		*
	*/
	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	/*********************************************************************************************
	* Update the URL to include the selected variant ID.
		*
	*/
	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}


	/*********************************************************************************************
	* Fetch variant data from the server and cache it.
		*
	*/
	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	/*********************************************************************************************
	* Render variant information in the DOM.
		*
		* @param {Document} html - The HTML document containing the variant information.
	*/
	renderVariantInfo(html) {
		// Mise à jour des éléments de base
		this.updateElementOuter("#product_id", html);
		this.updateElementOuter("#product_form_selected_variant_id", html);
		this.updateElementOuter(".mm-product-price", html);
		this.updateMultipleElement(".mm-product-form-variant-value", html);
		this.updateElementOuter(".mm-product-cta", html);
		this.updateImagesVariant();

		// Mise à jour du composant complémentaire
		const complementaryContainer = this.container.querySelector('.mm-product-form-component-cta-and-complementary');
		if (complementaryContainer) {
			const complementaryInfo = html.querySelector('.mm-product-form-component-cta-and-complementary');
			if (complementaryInfo) {
				complementaryContainer.innerHTML = complementaryInfo.innerHTML;

				// Réinitialiser les écouteurs d'événements pour les nouvelles checkboxes
				complementaryContainer.querySelectorAll('.mm-check-upsell').forEach(checkbox => {
					checkbox.addEventListener('change', function() {
						mmHandleAddOrRemoveProduct(this);
					});
				});
			}
		}

		// Synchroniser avec le sticky CTA
		const stickyCTA = document.querySelector('.mm-product-sticky-cta');
		if (stickyCTA) {
			const stickyComplementaryInfo = html.querySelector('.mm-product-sticky-cta');
			if (stickyComplementaryInfo) {
				stickyCTA.innerHTML = stickyComplementaryInfo.innerHTML;

				// Réinitialiser les écouteurs d'événements pour les nouvelles checkboxes dans le sticky
				stickyCTA.querySelectorAll('.mm-check-upsell').forEach(checkbox => {
					checkbox.addEventListener('change', function() {
						mmHandleAddOrRemoveProduct(this);
					});
				});
			}
		}
	}

	/*********************************************************************************************
	* Update the inner HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of multiple elements.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateMultipleElement(selector, html) {
        const destination = this.container.querySelectorAll(selector);
        const source = html.querySelectorAll(selector);

        if (source && destination) {
            for (let index = 0; index < source.length; index++) {
                destination[index].outerHTML = source[index].outerHTML;
            }
        }
    }

	/*********************************************************************************************
	* Update the media carousel to display the featured media of the current variant.
		*
	*/
	updateMedia() {
        if (this.currentVariant && this.currentVariant.featured_media) {
            var variant_media_id = this.currentVariant.featured_media.id;
            var allMainMedia = document.querySelectorAll(".mm-product-medias .splide__slide");

            allMainMedia.forEach((media, index) => {
                if (media.dataset.id != null && parseInt(media.dataset.id) == variant_media_id) {
                    splideMainInstance.go(index);
                }
            });
        }
    }

	/*********************************************************************************************
	* Update the visibility of the media sliders for the current variant.
		*
	*/
	updateImagesVariant() {
        var allMainMedia = document.querySelectorAll(".main-slider-variant");
        allMainMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
        var allThumbnailMedia = document.querySelectorAll(".thumbnail-slider-variant");
        allThumbnailMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
    }
}

class VariantSelectorSticky extends VariantSelector {
  constructor() {
    super();
    this.container = this.closest(".mm-product-sticky-cta");
  }

  onVariantChange() {
    this.getSelectedOptions();
    this.getSelectedVariant();

    if (this.currentVariant) {
      this.updateURL();
      if (this.dataset.imageVariant) {
        this.updateImagesVariant();
      } else {
        this.updateMedia();
      }
      this.variantFetch();

      // Synchroniser avec le sélecteur principal
      const mainSelector = document.querySelector('variant-selector');
      if (mainSelector) {
        // Mettre à jour directement les options dans le sélecteur principal
        const options = this.currentVariant.options;
        const mainCheckboxes = mainSelector.querySelectorAll('.mm-product-variant-checkbox');
        mainCheckboxes.forEach(checkbox => {
          const optionIndex = parseInt(checkbox.getAttribute('data-option-index'));
          if (checkbox.value === options[optionIndex]) {
            checkbox.checked = true;
            const label = checkbox.closest('label');
            if (label) {
              label.classList.add('mm-active');
            }
          } else {
            checkbox.checked = false;
            const label = checkbox.closest('label');
            if (label) {
              label.classList.remove('mm-active');
            }
          }
        });

        // Mettre à jour le variant dans le sélecteur principal
        mainSelector.currentVariant = this.currentVariant;
        mainSelector.updateURL();
        mainSelector.updateMedia();
        mainSelector.variantFetch();
      }
    }
  }

  renderVariantInfo(html) {
    // Mise à jour des éléments de base
    this.updateElementOuter("#product_id", html);
    this.updateElementOuter("#product_form_selected_variant_id", html);
    this.updateElementOuter(".mm-product-price", html);
    this.updateMultipleElement(".mm-product-form-variant-value", html);
    this.updateElementOuter(".mm-product-cta", html);
    this.updateImagesVariant();

    // Mise à jour du produit complémentaire dans le sticky
    const complementaryContainer = this.container.querySelector('.mm-container-product-complementary');
    if (complementaryContainer) {
      const complementaryInfo = html.querySelector('.mm-container-product-complementary');
      if (complementaryInfo) {
        complementaryContainer.innerHTML = complementaryInfo.innerHTML;

        // Réinitialiser les écouteurs d'événements pour les nouvelles checkboxes
        complementaryContainer.querySelectorAll('.mm-check-upsell').forEach(checkbox => {
          checkbox.addEventListener('change', function() {
            mmHandleAddOrRemoveProduct(this);
          });
        });
      }
    }

    // Mise à jour du header du produit complémentaire
    const complementaryHeader = this.container.querySelector('.mm-header-complementary-product');
    if (complementaryHeader) {
      const complementaryHeaderInfo = html.querySelector('.mm-header-complementary-product');
      if (complementaryHeaderInfo) {
        complementaryHeader.innerHTML = complementaryHeaderInfo.innerHTML;
      }
    }

    // Synchroniser avec le conteneur principal
    const mainContainer = document.querySelector('.mm-product-form');
    if (mainContainer) {
      const mainComplementaryInfo = html.querySelector('.mm-product-form-component-cta-and-complementary');
      if (mainComplementaryInfo) {
        const mainComplementaryContainer = mainContainer.querySelector('.mm-product-form-component-cta-and-complementary');
        if (mainComplementaryContainer) {
          mainComplementaryContainer.innerHTML = mainComplementaryInfo.innerHTML;

          // Réinitialiser les écouteurs d'événements pour les nouvelles checkboxes dans le conteneur principal
          mainComplementaryContainer.querySelectorAll('.mm-check-upsell').forEach(checkbox => {
            checkbox.addEventListener('change', function() {
              mmHandleAddOrRemoveProduct(this);
            });
          });
        }
      }
    }

    // Réinitialiser les prix des CTA après mise à jour des variants
    resetCTAPrices();
  }
}

// Fonction pour réinitialiser les prix des CTA à leur valeur de base
function resetCTAPrices() {
	const ctaButtons = document.querySelectorAll('.mm-product-cta');

	ctaButtons.forEach(button => {
		// Récupérer le prix de base depuis l'attribut data-price du bouton
		const basePrice = parseFloat(button.getAttribute('data-price'));
		if (isNaN(basePrice)) return;

		// Vérifier si des produits complémentaires sont cochés
		const checkedComplementaries = document.querySelectorAll('.mm-check-upsell:checked');
		let totalComplementaryPrice = 0;

		checkedComplementaries.forEach(checkbox => {
			const container = checkbox.closest('.mm-container-product-complementary');
			if (container) {
				const priceElement = container.querySelector('[data-price]');
				if (priceElement) {
					const complementaryPrice = parseFloat(priceElement.getAttribute('data-price'));
					if (!isNaN(complementaryPrice)) {
						totalComplementaryPrice += complementaryPrice;
					}
				}
			}
		});

		// Calculer le nouveau prix total
		const newPrice = basePrice + totalComplementaryPrice;

		// Mettre à jour l'attribut data-price du bouton
		button.setAttribute('data-price', newPrice);

		// Mettre à jour le prix dans le span du bouton
		const priceSpan = button.querySelector('span');
		if (priceSpan) {
			// Le prix est en centimes, donc on divise par 100 pour obtenir les euros
			const priceText = (newPrice / 100).toFixed(2).replace('.', ',') + "€";
			priceSpan.textContent = priceText;
		}
	});
}

/*********************************************************************************************
* Define the custom element
	*
*/
customElements.define("variant-selector", VariantSelector);
customElements.define("variant-selector-sticky", VariantSelectorSticky);


/*********************************************************************************************
* Loaded Listenner
	*
*/
document.addEventListener("DOMContentLoaded", () => {
	mmInitSplideReaProduct();
      mmInitSplideReaProductOrder();
	initializeStickyCTA();
  // mmInitSplideReaProductSticky();
	handleModalePediPosition();

	// Ajout des écouteurs d'événements pour les checkboxes des produits complémentaires
	document.querySelectorAll('.mm-check-upsell').forEach(checkbox => {
		checkbox.addEventListener('change', function() {
			mmHandleAddOrRemoveProduct(this);

			// Gestion de l'animation de la checkbox
			const label = this.nextElementSibling;
			if (label && label.classList.contains('mm-checkbox-anim-outer')) {
				if (this.checked) {
					label.classList.add('mm-checkbox-checked');
				} else {
					label.classList.remove('mm-checkbox-checked');
				}
			}
		});
	});
});

function mmAddProductToCart(variantId, { quantity = 1, openCart = true } = {}) {
	// Utiliser l'API cart de mm_cart.js avec openCart: false pour ne pas ouvrir le panier
	mmAPIRequest("POST", "cart/add.js", {
		items: [{
			id: variantId,
			quantity: quantity
		}],
		sections: mmCartSectionId(),
	})
	.then(refreshCartFromData)
	.then((data) => {
		if (openCart) {
			setTimeout(mmOpenCart, 100);
		}
		console.log('Produit ajouté avec succès:', data);
	})
	.catch((error) => {
		alert(error.message);
		console.error('Erreur lors de l\'ajout au panier:', error);
	});
}

function mmDestroyProductFromCart(variantId) {
	// Utiliser l'API cart de mm_cart.js pour supprimer par variantId
	mmAPIRequest("POST", "cart/change.js", {
		id: variantId,
		quantity: 0,
		sections: mmCartSectionId(),
	})
	.then(refreshCartFromData)
	.then((data) => {
		console.log('Produit supprimé avec succès:', data);
	})
	.catch((error) => {
		alert(error.message);
		console.error('Erreur lors de la suppression du panier:', error);
	});
}
